import { OrbitControls } from "./OrbitControls.oc";
import { v3 } from "oc-threejs/short3";

import { Camera, Spherical, Vector3 } from "three";

export class OrbitControlsOC extends OrbitControls {
  declare state: any;

  polarAngleLocked: boolean = false;
  minCameraTargetPosition: Vector3 = v3(-Infinity, -Infinity, -Infinity);
  maxCameraTargetPosition: Vector3 = v3(Infinity, Infinity, Infinity);
  minCameraPosition: Vector3 = v3(-Infinity, -Infinity, -Infinity);
  maxCameraPosition: Vector3 = v3(Infinity, Infinity, Infinity);

  constructor(object: Camera, domElement: HTMLElement) {
    super(object, domElement);
  }

  // Overridden method from OrbitControls
  defineAdditionalMembers(): void {
    this.polarAngleLocked = false;
    this.minCameraTargetPosition = v3(-Infinity, -Infinity, -Infinity);
    this.maxCameraTargetPosition = v3(Infinity, Infinity, Infinity);
    this.minCameraPosition = v3(-Infinity, -Infinity, -Infinity);
    this.maxCameraPosition = v3(Infinity, Infinity, Infinity);
  }

  resetFromObjectAndTarget(): void {
    this.object.updateProjectionMatrix();
    this.dispatchEvent(this.changeEvent);
    this.update();
    this.state = this.STATE.NONE;
  }

  onMouseWheelStartExtension(event: Event): void {
    this.state = this.STATE.DOLLY;
  }

  onMouseWheelEndExtension(event: Event): void {
    this.state = this.STATE.NONE;
  }

  onKeyDownExtension(event: KeyboardEvent): boolean {
    const target = event.target as HTMLElement;
    const tagname = target.tagName.toLowerCase();
    return !(tagname === "input" || tagname === "select" || tagname === "textarea");
  }

  addTargetToPosition(position: Vector3, target: Vector3, offset: Vector3): void {
    target.clamp(this.minCameraTargetPosition, this.maxCameraTargetPosition);
    position.copy(target).add(offset);
    position.clamp(this.minCameraPosition, this.maxCameraPosition);
  }

  processSpherical(sphericalDelta: Spherical): void {
    if (this.polarAngleLocked) {
      sphericalDelta.phi = 0;
    }
  }
}
